import { createGlobalStyle } from 'styled-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { widgetUrlSelector } from '../features/userPreferences';

const FontsProvider = () => {
  const url = useSelector(widgetUrlSelector);
  return <Fonts $assetsUrl={url}></Fonts>;
};

interface FontsProps {
  $assetsUrl: string;
}

const Fonts = createGlobalStyle<FontsProps>`
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-Light.ttf') format('woff');
  font-weight: 300;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-LightItalic.ttf') format('woff');
  font-weight: 300;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-Italic.ttf') format('woff');
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-Regular.ttf') format('woff');
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-Medium.ttf') format('woff');
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-MediumItalic.ttf') format('woff');
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-SemiBold.ttf') format('woff');
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-SemiBoldItalic.ttf') format('woff');
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-Bold.ttf') format('woff');
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-BoldItalic.ttf') format('woff');
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-ExtraBold.ttf') format('woff');
  font-weight: 800;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Poppins';
  src: url('${(props) => props.$assetsUrl}fonts/Poppins-ExtraBoldItalic.ttf') format('woff');
  font-weight: 800;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}

@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-Thin.ttf') format('woff');
  font-weight: 100;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-Light.ttf') format('woff');
  font-weight: 300;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-Regular.ttf') format('woff');
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-Bold.ttf') format('woff');
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-Black.ttf') format('woff');
  font-weight: 900;
  font-stretch: 100%;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-ThinItalic.ttf') format('woff');
  font-weight: 100;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}
@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-LightItalic.ttf') format('woff');
  font-weight: 300;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}
@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-BoldItalic.ttf') format('woff');
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}
@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-BoldItalic.ttf') format('woff');
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}
@font-face {
  font-family: 'Lato';
  src: url('${(props) => props.$assetsUrl}fonts/Lato-BlackItalic.ttf') format('woff');
  font-weight: 900;
  font-stretch: 100%;
  font-display: swap;
  font-style: italic;
}

`;

export default FontsProvider;
